export default __webpack_public_path__ + "static/media/bannerBottomLeft.d4886f62.jpeg";